import { apiClient } from "./apiClient"

export const groupApi = {
    insertGroup: async (businessEntityId, group, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/organizations/${businessEntityId}/groups`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                body:JSON.stringify(group)
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.group
                    }
                )
            }
        )
    },
    fetchGroup: async (groupId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/groups/${groupId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        return result.group
                    }
                )
            }
        )
    },
    updateGroup: async (id, group, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/groups/${id}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override': "PUT"
                },
                body: JSON.stringify(group)
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.group
                    }
                )
            }
        )
    },
    fetchGroupBusinessEntities: async (businessEntityId, config, accessToken) => {
        const url = `${config.securityApiUrl}/businessentities/${businessEntityId}/groupBusinessEntities`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        return result.groupBusinessEntity
                    }
                )
            }
        )
    },
    fetchGroupUserList: async (groupId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/groups/${groupId}/users`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        return result.users
                    }
                )
            }
        )
    },
    fetchGroupRoleBusinessEntities: async (businessEntityId, groupId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/groups/${groupId}/roleBusinessEntities?parentBusinessEntityId=${businessEntityId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        return result.groupRoleBusinessEntities
                    }
                )
            }
        )
    },
    deleteGroupRoleBusinessEntity: async (groupId, roleId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/groups/${groupId}/roleBusinessEntities/${roleId}`
        if (!roleId) {
            throw Error("Role ID is undefined")
        }
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override': "DELETE"
                }
            },
            null
        )
    },
    fetchGroupList: async (businessEntityId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/organizations/${businessEntityId}/groups`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (json) => {
                        return json.groups
                    }
                )
            }
        )
    },
    fetchCanGrantGroupList: async (businessEntityId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/organizations/${businessEntityId}/groups?canGrant=true`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return response.json().then(
                    (json) => {
                        return json.groups
                    }
                )
            }
        )
    },
    fetchCanGrantGroupList: async (businessEntityId, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/organizations/${businessEntityId}/groups?canGrant=true`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET",
                headers: {
                    'ClientId': '3'
                }
            },
            async (response) => {
                return response.json().then(
                    (json) => {
                        return json.groups
                    }
                )
            }
        )
    },
    deleteGroup: async function (groupId, config, accessToken) {
        const url = `${config.accountServiceBaseUrl}/api/groups/${groupId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override': 'DELETE'
                }
            },
            (response) => {
                return response
            }
        )
    },
    addGroupRoleBusinessEntity: async (groupId, roleBusinessEntity, config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/groups/${groupId}/roleBusinessEntities`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                body: JSON.stringify(roleBusinessEntity)
            },
            async (response) => {
                return response.json().then(
                    (result) => {
                        //console.log("Got the following result from adding a role business entity for this group:")
                        //console.log(result)
                        return result.groupRoleBusinessEntities
                    }
                )
            }
        )
    },
    addGroupUsers: async (groupId, userIds, config, accessToken) => {
        const f = `groupApi.addGroupUsers()`
        console.log(`${f}: entered`)
        const url = `${config.accountServiceBaseUrl}/api/groups/${groupId}/users`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override':'PATCH'
                },
                body: JSON.stringify(userIds)
            },
            async (response) => {
                console.log(`${f} inside transformer`)
                return response.json().then(
                    (result) => {
                        console.log(`${f}: parsed JSON, about to return the following:`)
                        console.log(result.users)
                        return result.users
                    }
                )
            }
        )
    },
    removeUserFromGroup: async (userId, groupId, config, accessToken) => {
        const f = `groupApi.removeUserFromGroup()`
        //users/{userId:int:min(1)}/groups/{groupId:int:min(1)}
        const url = `${config.accountServiceBaseUrl}/api/users/${userId}/groups/${groupId}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "POST",
                headers: {
                    'X-HTTP-Method-Override': 'DELETE'
                }
            },
            async (response) => {
                console.log(`${f} inside transformer function with the following response:`)
                console.log(response)
                return response
            }
        )
    }
}